import { useState } from "react";
import { Get } from "../../../../Request";

export const useFaq = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({});
  const getData = async () => {
    setLoading(true);
    Get({
      url: "/questioncategory/show",
    }).then(response => {
      setData(response);
      setLoading(false);
    });
  };
  return {
    data,
    loading,
    form,
    setForm,
    getData,
  };
};
